export default __webpack_public_path__ + "static/media/dropdown-orange-icon.953a58f2.svg";